import { format, subMonths } from 'date-fns';

export function getPreviousMonth(): number {
  try {
    const now = new Date();

    const prevMonth = subMonths(now, 1); // 2024-11-30
    return parseInt(format(prevMonth, 'M'));
  } catch (error) {
    console.error('Invalid timeZone:', error);
    throw new Error(`Invalid timezone`);
  }
}
